import { Outlet } from 'react-router';
import Header from '../header/Header';
import { SidebarProvider, SidebarTrigger } from '../ui/sidebar';
import { AppSidebar } from '../sidebar/Sidebar';

export default function Layout() {
  return (
    <main className="flex">
      <SidebarProvider>
        <AppSidebar />

        <SidebarTrigger className="bg-background" />
        <div className="flex flex-col w-full h-full md:overflow-y-auto">
          <Header />
          <div className="md:overflow-x-auto max-md:overflow-auto max-w-full">
            {<Outlet />}
          </div>
        </div>
      </SidebarProvider>
    </main>
  );
}
